import { forwardRef, useImperativeHandle, useRef } from 'react';

import { extractPlaceInfo } from '@barboxx/admin-utils';
import { Place } from '@barboxx/models';

import { SearchMap, SearchMapRefProps } from '../../components/SearchMap';

interface Props {
    updateFormData: (data: Place.UpdateRequest) => void;
    currentPlace: Place;
}

export interface CurrentPlaceMapRefProps {
    reset: () => void;
}

export const CurrentPlaceMap = forwardRef(function CurrentPlaceMap(
    { updateFormData, currentPlace }: Props,
    ref
) {
    useImperativeHandle(ref, () => ({
        reset,
    }));

    const mapRef = useRef<SearchMapRefProps | null>(null);

    const center = {
        lat: currentPlace.latitude,
        lng: currentPlace.longitude,
    };

    const handleBusinessSelect = (data: google.maps.places.PlaceResult) => {
        const businessData = extractPlaceInfo(data);
        updateFormData({ id: currentPlace.id, ...businessData });
    };

    const handlePlaceSelect = () => {
        updateFormData(currentPlace);
    };

    const reset = () => {
        mapRef.current?.clear();
    };

    return (
        <SearchMap
            possiblePlaces={[currentPlace]}
            onBusinessSelect={handleBusinessSelect}
            center={center}
            onSelectPlace={handlePlaceSelect}
            ref={mapRef}
        />
    );
});
